<template>
  <section class="section">
    <div class="container">
      <div class="columns">
        <div class="column">
          <h2 class="title">
            Department of Clinic
          </h2>
        </div>
      </div>
      <b-tabs v-model="activeTab" v-if="roleid == 9">
        <b-tab-item label="ຟອມເພີ່ມ/ ແກ້ໄຂສິນຄ້າ">
          <div class="columns">
            <div class="column">
              <h3 class="title">ເພິ່ມ/ ແກ້ໄຂສິນຄ້າ</h3>
            </div>
          </div>
          <div class="columns" v-if="adddataform">
            <div class="column">
              <div class="columns">
                <div class="column">
                  <b-field label="ຊື່ສິນຄ້າ">
                    <b-input v-model.trim="productname"> </b-input>
                  </b-field>
                </div>
                <div class="column">
                  <b-field label="ຊື່ສິນຄ້າ (ອັງກິດ)">
                    <b-input v-model.trim="productnameen"> </b-input>
                  </b-field>
                </div>
                <div class="column">
                  <b-field label="ຫົວໜ່ວຍ">
                    <b-input v-model.trim="unit"> </b-input>
                  </b-field>
                </div>
                <div class="column">
                  <b-field label="ປະເພດ">
                    <Multiselect
                      placeholder="ເລືອກ"
                      v-model.trim="selectedType"
                      label="NAME"
                      track-by="ID"
                      :options="typeList"
                      @input="onTypeSelected()"
                    >
                    </Multiselect>
                  </b-field>
                </div>
                <div class="column">
                  <b-field label="ການເກັບກ່ຽວ" >
                    <Multiselect v-if="disabledstate"
                      placeholder="ເລືອກ"
                      v-model.trim="selectedHarvesttype"
                      label="NAME"
                      track-by="ID"
                      :options="harvesttype"
                     
                    >
                    </Multiselect>
                  </b-field>
                </div>
                <!-- <div class="column">
                  <button class="button is-info" onclick="document.getElementById('fileupload').click()">ເລືອກຮູບ </button>
                  <input type="file"  id="fileupload" @change="onFileSelected" style="visibility:hidden;" />
                </div> -->
              </div>
              <div class="columns">
                <div class="column">
                  <b-field label="ຊື່ພິເສດ">
                    <b-input v-model.trim="specialname"> </b-input>
                  </b-field>
                </div>
                <div class="column">
                  <b-field grouped position="is-right">
                    <div class="buttons">
                      <b-button
                        expanded
                        type="is-primary"
                        onclick="document.getElementById('fileupload').click()"
                        >ເລືອກຮູບ -
                      </b-button>
                    </div>
                  </b-field>
                  <b-field label="" style="float: right">
                    <b-field v-if="saveAction">
                      <button class="button is-info" @click="saveProduct">
                        ບັນທຶກສິນຄ້າ
                      </button>
                    </b-field>
                    <b-field v-if="updateAction">
                      <div class="columns">
                        <div class="column">
                          <b-field>
                            <button
                              class="button is-primary"
                              @click="updateProduct"
                            >
                              ແກ້ໄຂສິນຄ້າ
                            </button>
                          </b-field>
                        </div>
                        <div class="column">
                          <b-field>
                            <button
                              class="button is-info"
                              @click="openSaveBranchForm"
                            >
                              ຟອມເພີ່ມສິນຄ້າ
                            </button>
                          </b-field>
                        </div>
                      </div>
                    </b-field>
                  </b-field>
                </div>
              </div>
              <div class="columns">
                <div class="column">
                  <b-field
                    grouped
                    position="is-centered"
                    v-if="isSelectPhoto || updateAction"
                  >
                    <img
                      data-v-xcxcc
                      :src="photopreview"
                      width="500"
                      height="500"
                    />
                    <!-- <img data-v-xcxcc src="http://accounting.houngsanaxay.com/accountingapi//khong0.PNG" /> -->
                  </b-field>
                  <input
                    type="file"
                    id="fileupload"
                    @change="onFileSelected"
                    style="visibility:hidden;"
                  />
                </div>
              </div>
            </div>
          </div>
        </b-tab-item>

        <b-tab-item label="ສິນຄ້າ ທີ່ເປີດໃຊ້ງານ">
          <div class="columns">
            <div class="column">
              <b-field style="margin-left: 20px" grouped>
    
                <b-field label="ຄົ້ນຫາສິນຄ້າ">
                  <input
                    type="text"
                    class="input"
                    v-model="search"
                    v-on:keyup="productSearch"
                  />
                </b-field>

                <!-- <b-field
                  label="ເລືອກປະເພດສິນຄ້າ"
                  style="margin-right: 15px; margin-left: 20px;"
                >
                </b-field> -->
                <b-field label="ປະເພດສິນຄ້າ">
                  <Multiselect
                    placeholder="ເລືອກ"
                    v-model.trim="selectedTypeSearch"
                    label="NAME"
                    track-by="ID"
                    :options="typeList"
                    @input="productTypeSelectedSearch"
                  >
                  </Multiselect>
                </b-field>
                <b-field label="ເກັບກ່ຽວ">
                  <Multiselect
                    placeholder="ເລືອກ"
                    v-model.trim="selectedHarvestSearch"
                    label="NAME"
                    track-by="ID"
                    :options="harvesttype"
                    @input="onHarvestSearch"
                  >
                  </Multiselect>
                </b-field>
              </b-field>

              <b-field label="ສິນຄ້າ ທີ່ເປີດໃຊ້ງານ">
                <table class="table is-fullwidth is-narrow is-small">
                  <thead>
                    <tr>
                      <th class="has-text-centered " width="5%">#</th>

                      <th class="has-text-left " width="15%">
                        ສິນຄ້າ
                      </th>
                      <th class="has-text-left " width="15%">
                        ສິນຄ້າ (ອັງກິດ)
                      </th>

                      <th class="has-text-left " width="15%">
                        ຫົວໜ່ວຍ
                      </th>
                      <th class="has-text-left " width="15%">
                        ປະເພດ
                      </th>
                      <th class="has-text-left " width="15%">
                        ເກັບກ່ຽວ
                      </th>
                      <th class="has-text-left " width="15%">
                        ຮູບ
                      </th>
                      <th class="has-text-centered " width="10%">
                        ຈັດການ
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="(data, index) in activeproducts"
                      :key="data.PRODUCTID"
                    >
                      <td class="has-text-centered">{{ index + 1 }}</td>

                      <td>
                        {{ data.PRODUCTNAME }}
                      </td>
                      <td>
                        {{ data.PRODUCTNAMEEN }}
                      </td>
                      <td>
                        {{ data.UNIT }}
                      </td>
                      <td>
                        {{ data.PRODUCTTYPENAME }}
                      </td>
                      <td>
                        <span v-if="data.HARVESTONE == 1">ຄັ້ງດຽວ</span>
                        <span v-if="data.HARVESTONE == 0">ຫຼາຍຄັ້ງ</span>
                      </td>
                      <td>
                        <!-- {{data.PHOTONAME}} -->
                        <img
                          data-v-xcxcc
                          :src="getImgUrl(data.PHOTONAME)"
                          width="100"
                          height="100"
                        />
                      </td>

                      <td class="has-text-centered">
                        <b-field group>
                          <b-field>
                            <b-button
                              class="btn-group-margin"
                              type="is-info"
                              size="is-small"
                              @click="productGradeForm(data)"
                              >ຈັດເກຼດສິນຄ້າ
                            </b-button>
                          </b-field>

                          <b-field>
                            <b-button
                              class="btn-group-margin"
                              type="is-primary"
                              size="is-small"
                              @click="updateProductForm(data)"
                              >ແກ້ໄຂ
                            </b-button>
                          </b-field>
                          <b-field>
                            <b-button
                              class="btn-group-margin"
                              type="is-danger"
                              size="is-small"
                              @click="changeProductStatus(data.PRODUCTID, 0)"
                              >ປິດໃຊ້ງານ
                            </b-button>
                          </b-field>
                        </b-field>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </b-field>
            </div>
          </div>
        </b-tab-item>

        <b-tab-item label="ສິນຄ້າ ທີ່ຖືກປິດ">
          <div class="columns scrollme">
            <div class="column">
              <b-field label="ສິນຄ້າ ທີ່ຖືກປິດ">
                <table class="table is-fullwidth is-narrow is-small">
                  <thead>
                    <tr>
                      <th class="has-text-centered " width="5%">#</th>

                      <th class="has-text-left " width="15%">
                        ສິນຄ້າ
                      </th>
                      <th class="has-text-left " width="15%">
                        ສິນຄ້າ (ອັງກິດ)
                      </th>

                      <th class="has-text-left " width="15%">
                        ຫົວໜ່ວຍ
                      </th>
                      <th class="has-text-left " width="15%">
                        ປະເພດ
                      </th>
                      <th class="has-text-left " width="15%">
                        ຮູບ
                      </th>
                      <th class="has-text-left " width="10%">
                        ຈັດການ
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="(data, index) in inactiveproducts"
                      :key="data.PRODUCTID"
                    >
                      <td class="has-text-centered">{{ index + 1 }}</td>

                      <td>
                        {{ data.PRODUCTNAME }}
                      </td>
                      <td>
                        {{ data.PRODUCTNAMEEN }}
                      </td>
                      <td>
                        {{ data.UNIT }}
                      </td>
                      <td>
                        {{ data.PRODUCTTYPENAME }}
                      </td>
                      <td>
                        <img
                          data-v-xcxcc
                          :src="getImgUrl(data.PHOTONAME)"
                          width="100"
                          height="100"
                        />
                      </td>
                      <td>
                        <b-field>
                          <b-button
                            class="btn-group-margin"
                            type="is-primary"
                            size="is-small"
                            @click="changeProductStatus(data.PRODUCTID, 1)"
                            >ເປີດໃຊ້ງານ
                          </b-button>
                        </b-field>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </b-field>
            </div>
          </div>
        </b-tab-item>

        <b-tab-item label="ຈັດເກຼດສິນຄ້າ">
          <div class="columns scrollme">
            <div class="column">
              <b-field :label="recommenttitle">
                <div class="columns">
                  <div class="column">
                    <b-field label="ຊື່ເກຼດ (ລາວ)">
                      <b-input v-model.trim="productgrade"> </b-input>
                    </b-field>
                    <b-field label="ຊື່ເກຼດ (ອັງກິດ)">
                      <b-input v-model.trim="productgrade_eng"> </b-input>
                    </b-field>
                    <b-field label="ຊື່ຫົວໜ່ວຍ(ລາວ)">
                      <b-input v-model.trim="gradunit"> </b-input>
                    </b-field>
                    <b-field label="ຊື່ຫົວໜ່ວຍ(ອັງກິດ)">
                      <b-input v-model.trim="gradunit_eng"> </b-input>
                    </b-field>
                    <b-field label="ອັດຕາສ່ວນ">
                      <b-input v-model.trim="subunit"> </b-input> 
                    </b-field> 
                    <b-field label="ລາຄາ">
                      <b-input v-model.trim="price"> </b-input> 
                    </b-field> 
                
                    <b-field label="ປະເພດ">
                      <Multiselect
                        placeholder="ເລືອກ"
                        v-model.trim="selectedB2BType"
                        label="NAME"
                        track-by="ID"
                        :options="b2bTypeList"
                      >
                      </Multiselect>
                    </b-field>
               
                    <b-field label="">
                      <!-- <button v-if="productgradecount <=4 && isaddgrade" 
                        class="button is-info"
                        @click="addProductGrade"
                      >
                      ເພີ່ມເກຼດ
                      </button>
                      <button v-else-if="productgradecount >=5 || !isaddgrade" 
                        disabled
                        class="button is-danger"
                        @click="addProductGrade"
                      >
                         ບໍ່ສາມາດ ເພີ່ມເກຼດ ເນື່ອງຈາກຮອດ {{productgradecount}} ລາຍການແລ້ວ
                      </button> -->
                      <button
                        class="button is-info"
                        @click="addProductGrade"
                      >
                      ເພີ່ມເກຼດ
                      </button>
                      

                      <button
                        v-if="!isaddgrade"
                        class="button is-primary" 
                        @click="updateProductGrade"
                      >
                        ແກ້ໄຂເກຼດ
                      </button>
                    </b-field>
                  </div>
                  <div class="column"></div>
                  <div class="column"></div>
                </div>
              </b-field>
            </div>
          </div>
          <div class="columns">
            <div class="column">
              <table class="table is-fullwidth is-narrow is-small">
                <thead>
                  <tr>
                    <th class="has-text-centered " width="5%">#</th>
                    <th class="has-text-left " width="15%">
                      ເກຼດ (ລາວ)
                    </th>
                    <th class="has-text-left " width="15%">
                      ເກຼດ (ອັງກິດ)
                    </th>
                    <th class="has-text-left " width="10%">
                      ຊື່ຫົວໜ່ວຍ (ລາວ)
                    </th>
                    <th class="has-text-left " width="10%">
                      ຊື່ຫົວໜ່ວຍ (ອັງກິດ)
                    </th>
                    <th class="has-text-left " width="10%">
                      ອັດຕາສ່ວນ
                    </th>
                    <th class="has-text-left " width="10%">
                      ປະເພດ
                    </th>
                    <th class="has-text-centered " width="10%">
                      ຈັດການ
                    </th>
                  </tr>
                </thead> 
                <tbody>
                  <tr v-for="(data, index) in productgradelist" :key="data.ID">
                    <td class="has-text-centered" v-bind:style="{ 'background-color': data.STATUS === 1 ? '' : '#607D8B' }">{{ index + 1 }}</td>
                    <td v-bind:style="{ 'background-color': data.STATUS === 1 ? '' : '#607D8B' }">
                      {{ data.PRODUCTNAME_SUB }}
                    </td>
                    <td v-bind:style="{ 'background-color': data.STATUS === 1 ? '' : '#607D8B' }"> 
                      {{ data.PRODUCTNAME_ENSUB }}
                    </td>
                    <td v-bind:style="{ 'background-color': data.STATUS === 1 ? '' : '#607D8B' }">
                      {{ data.GRADUNIT }}
                    </td>
                    <td v-bind:style="{ 'background-color': data.STATUS === 1 ? '' : '#607D8B' }">
                      {{ data.GRADUNIT_ENG }}
                    </td>
                    <td v-bind:style="{ 'background-color': data.STATUS === 1 ? '' : '#607D8B' }">
                      {{ data.SUBUNIT }}
                    </td>
                    <td v-bind:style="{ 'background-color': data.STATUS === 1 ? '' : '#607D8B' }">
                      <span v-if="data.PACKINGTYPE==2" style="color:red">
                        {{ data.PACKINGTYPENAME }}
                      </span>
                      <span v-else>
                        {{ data.PACKINGTYPENAME }}  
                      </span>
                    </td>

                    <td class="has-text-centered" v-bind:style="{ 'background-color': data.STATUS === 1 ? '' : '#607D8B' }">
                      <b-field group>
                        <b-field>
                          <b-button
                            class="btn-group-margin"
                            type="is-primary"
                            size="is-small"
                            @click="updateProductGradeForm(data)"
                            >ແກ້ໄຂ
                          </b-button>
                        </b-field>
                      </b-field>
                      <b-field group>
                        <b-field>
                          <b-button
                            class="btn-group-margin"
                            :type="{ 'is-danger': data.STATUS === 1, 'is-info': data.STATUS === 0 }"  
                            size="is-small"
                            @click="changeProductGrade(data)"
                            >{{ data.STATUS === 1 ? 'ປິດໃຊ້ງານ' : 'ເປິດໃຊ້ງານ' }}
                          </b-button>
                          <!-- <b-button v-else-if="data.STATUS==0"
                            class="btn-group-margin"
                            type="is-info"
                            size="is-small"
                            @click="changeProductGrade(data, 1)"
                            >ເປິດໃຊ້ງານ
                          </b-button> -->
                        </b-field>
                      </b-field>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </b-tab-item>
      </b-tabs>
    </div>
  </section>
</template>

<script>
import RestAPI from "../../RestAPI";
import Multiselect from "vue-multiselect";
import axios from "axios";

export default {
  components: { Multiselect },
  props: ["MONTH"],
  data() {
    return {
      roleid: null,
      userName: null,
      selectedType: [],
      selectedB2BType: [],
      selectedTypeSearch: null,
      typeList: [],
      b2bTypeList: [
        { ID: "1", NAME: "Normal" },
        { ID: "2", NAME: "Hawker Chan" },
      ], 
      // isProvinceSelected: false,
      // selectedProvince: null,
      // provinceList:  [],
      // selectedUser: null,
      // userList: [],

      selectedHarvestSearch :null,

      activeproducts: [],
      inactiveproducts: [],
      productid: null,
      oldproductname: null,
      productname: null,
      oldproductnameen: null,
      productnameen: null,
      oldunit: null,
      unit: null,
      oldphotoname: null,

      harvesttype: [
        { ID: "1", NAME: "ຄັ້ງດຽວ" },
        { ID: "0", NAME: "ຫຼາຍເທື່ອ" },
      ], 
      selectedHarvesttype: [],
      specialname: null,

      selectedFile: null,
      url: "uploadimage", // function name in api site
      photoname: null,
      photopath:
        process.env.NODE_ENV === "production"
          ? "https://agrilao.com/manager-main/api/uploads/products/"
          : "http://localhost/agrilao-manager/api/uploads/products/",
      // photopath: process.env.NODE_ENV === "production" ? "http://51.222.85.54/agrilao-manager/api/uploads/products/" : "http://localhost/agrilao-manager/api/uploads/products/",
      photopreview: null,
      isSelectPhoto: false,

      // oldbranchenname: null,
      // branchenname: null,
      // countryid: null,
      // provinceid: null,
      // oldprovinceid: null,
      // responseusername: null,
      // oldresponseusername: null,

      productgrade: null,
      productgrade_eng: null,
      subunit: null,
      oldsubunit: null,
      gradunit: null,
      gradunit_eng: null,
      productgradelist: [],
      productgradecount: 0,
      productgradeid: null,
      isaddgrade: true,
      price: 0,
      productphotoname: null,

      activeTab: 1,
      saveAction: true,
      updateAction: false,
      adddataform: true,
      updatedataform: false,

      recommenttitle: null,
      provinceList: [],
      activeSubTab: 0,
      monthList: [
        { ID: "1", NAME: "01" },
        { ID: "2", NAME: "02" },
        { ID: "3", NAME: "03" },
        { ID: "4", NAME: "04" },
        { ID: "5", NAME: "05" },
        { ID: "6", NAME: "06" },
        { ID: "7", NAME: "07" },
        { ID: "8", NAME: "08" },
        { ID: "9", NAME: "09" },
        { ID: "10", NAME: "10" },
        { ID: "11", NAME: "11" },
        { ID: "12", NAME: "12" },
      ],
      search: null,
      disabledstate: false,

      selectedProductID: null,

      // selectedBranchProvince: null,
      // branchProvinceList: [],
    };
  },
  methods: {
    onTypeSelected(){
      this.selectedHarvesttype = null;
      if(this.selectedType.ISFARMING =='1'){
        this.disabledstate = true;
        
      }else{
        this.disabledstate= false;
      }
    },
    getProductTypes() {
      RestAPI.getClinicProductAllTypes()
        .then((res) => {
          console.log("getClinicProductTypes: " + JSON.stringify(res.data));
          this.typeList = res.data;
        })
        .catch((error) => {
          console.log(error);
          this.$swal("ມີຂໍ້ຜິດພາດ", "-", "error");
        });
    },
    getResponseUser() {
      RestAPI.getResponseUser(3)
        .then((res) => {
          // console.log("con: "+ JSON.stringify(res.data))
          if (this.updateAction == true) {
            this.userList = res.data;
            this.userList.push(this.selectedUser);
          }

          this.userList = res.data;
        })
        .catch((error) => {
          console.log(error);
          this.$swal("ມີຂໍ້ຜິດພາດ", "-", "error");
        });
    },
    getProvince() {
      RestAPI.getProvincebyCountry(this.selectedCountry.ID)
        .then((res) => {
          // console.log("country selected...")
          this.provinceList = res.data;
        })
        .catch((error) => {
          console.log(error);
          this.$swal("ມີຂໍ້ຜິດພາດ", "-", "error");
        });
    },
    getAllProvince() {
      RestAPI.getAllProvince()
        .then((res) => {
          this.branchProvinceList = res.data;
          //  console.log("branchProvinceList: " + JSON.stringify(this.branchProvinceList))
        })
        .catch((error) => {
          console.log(error);
          this.$swal("ມີຂໍ້ຜິດພາດ", "-", "error");
        });
    },
    onSelectBranchProvince(branchid, provinceid) {
      var params = {
        branchid: branchid,
        provinceid: provinceid.ID,
        username: this.username,
      };

      // console.log("pa: " + JSON.stringify(params))

      RestAPI.addProvinceToBranch(params)
        .then(() => {
          this.countryid = null;
          this.provinceid = null;
          this.getBranches();
        })
        .catch((error) => {
          console.log(error);
          if (error == "Error: Request failed with status code 400") {
            this.$swal("Check Input Data", "", "error");
          } else {
            this.$swal("ມີຂໍ້ຜິດພາດ: " + error, "-", "error");
          }
        });
    },
    saveProduct() {
      // console.log("this.selectedProvince.ID: " + this.selectedProvince.length)
      if (
        this.productname === null ||
        this.productnameen === null ||
        this.unit === null ||
        this.selectedType === null
        
      ) {
        this.$swal("ກະລຸນາປ້ອນຂໍ້ມູນໃຫ້ຄົບຖ້ວນ", "", "error");

      }else if (this.selectedType.ISFARMING =='1' && this.selectedHarvesttype === null ){
        this.$swal("ກະລຸນາປ້ອນຂໍ້ມູນໃຫ້ຄົບຖ້ວນ", "", "error");

      } else {
        var harvest;
        if(this.selectedType.ISFARMING =='1'){
          harvest = this.selectedHarvesttype.ID;
        }else{
          harvest = 2;
        }

        var params = {
          productname: this.productname,
          productnameen: this.productnameen,
          specialname: this.specialname,
          typeid: this.selectedType.ID,
          harvesttype: harvest,
          unit: this.unit,
          photoname: this.photoname,
          username: this.username,
        };
        // console.log("params: " + JSON.stringify(params));
        RestAPI.saveProduct(params)
          .then((res) => {
            // console.log("data: " + JSON.stringify(res.data))
            if (res.data == "duplicate productname") {
              this.$swal("ຊື່ສິນຄ້າຊ້ຳ", "-", "error");
              return false;
            }

            this.photopreview = null;
            this.$swal("ບັນທືກສິນຄ້າ ສຳເລັດ!", "", "success");

            this.productname = null;
            this.productnameen = null;
            this.unit = null;
            this.selectedType = null;
            (this.selectedHarvesttype = null), this.getProducts();
            this.activeTab = 1;
          })
          .catch((error) => {
            console.log(error);
            if (error == "Error: Request failed with status code 400") {
              this.$swal("Check Input Data", "", "error");
            } else {
              this.$swal("ມີຂໍ້ຜິດພາດ: " + error, "-", "error");
            }
          });
      }
    },
    getProducts() {
      RestAPI.getClinicProducts('nofarming')
        .then((res) => {
          // console.log("list:"+ JSON.stringify(res.data))
          this.activeproducts = res.data.activeproducts;
          this.inactiveproducts = res.data.inactiveproducts;
        })
        .catch((error) => {
          console.log(error);
          this.$swal("ມີຂໍ້ຜິດພາດ", "-", "error");
        });
    },
    getProdudtGrade() {
      this.productgradelist = [];
      RestAPI.getProductGrade(this.productid)
        .then((res) => {
          // console.log("productid: " + this.productid)
          // console.log("getProductGrade: " + JSON.stringify(res.data.subunit))
          // if(res.data.subunit['countsubunit'] > 1){
          //     this.$swal("ມີອັດຕາສ່ວນເທົ່າ 1 ແລ້ວ", "", "error");
          //     return false;
          // }

          // if(res.data.subunit['countsubunit']  === 0){
          //     this.$swal("ບໍ່ມີອັດຕາສ່ວນເທົ່າ 1 ເລີຍ", "", "error");
          //     return false;
          // }
          
          this.productgradelist = res.data.grade.list;
          this.productgradecount = res.data.grade.count.COUNTNUMBER;

        })
        .catch((error) => {
          console.log(error);
          this.$swal("ມີຂໍ້ຜິດພາດ", "-", "error");
        });
    },
    productGradeForm(data) {
      this.activeTab = 3;
      this.recommenttitle = "ຈັດເກຼດ " + data.PRODUCTNAME;
      this.productid = data.PRODUCTID;
      this.getProdudtGrade(data.PRODUCTID);
      this.productgrade = data.PRODUCTNAME;
      this.productgrade_eng = data.PRODUCTNAMEEN;
      this.subunit = null;
      this.gradunit = null;
      this.gradunit_eng = null;
      this.productphotoname = data.PHOTONAME;
    },

    updateProductGradeForm(data) {
      this.productgrade = data.PRODUCTNAME_SUB;
      this.productgrade_eng = data.PRODUCTNAME_ENSUB;
      this.subunit = data.SUBUNIT;
      this.oldsubunit = data.OLDSUBUNIT;
      this.gradunit = data.GRADUNIT;
      this.gradunit_eng = data.GRADUNIT_ENG;
      this.productgradeid = data.ID;
      this.selectedB2BType = {
        ID: data.PACKINGTYPE,
        NAME: data.PACKINGTYPENAME,
      };
      this.isaddgrade = false;
      this.selectedProductID = data.PRODUCTID;
    },

    updateProductGrade() {
      if (
        this.productgrade === null || this.productgrade === null ||
        this.productgrade_eng === null || this.productgrade_eng === null ||
        this.subunit === null || this.subunit === null ||
        this.gradunit === null || this.gradunit === null ||
        this.gradunit_eng === null || this.gradunit_eng === null ||
        this.selectedB2BType === null || this.selectedB2BType.length === 0
      ) {
        this.$swal("ກະລຸນາປ້ອນຂໍ້ມູນໃຫ້ຄົບຖ້ວນ", "", "error");
      } else {
        var params = {
          productid: this.selectedProductID,
          productgradeid: this.productgradeid,
          productgrade: this.productgrade,
          productgrade_eng: this.productgrade_eng,
          oldsubunit: this.oldsubunit,
          subunit: this.subunit,  
          gradunit: this.gradunit,
          gradunit_eng: this.gradunit_eng,
          b2bpackingtype: this.selectedB2BType.ID,
          username: this.username,
          
        };
        console.log("params: " + JSON.stringify(params));
        RestAPI.updateProductGrade(params)
          .then(res => {
            if(res.data === "morethan1"){
              this.$swal("ມີອັດຕາສ່ວນເທົ່າ 1 ແລ້ວ", "", "error");
              return false;
            }
            this.photopreview = null;
            this.$swal("ແກ້ໄຂເກຼດສິນນຄ້າ ສຳເລັດ!", "", "success");
            this.productgrade = null;
            this.productgrade_eng = null;
            this.subunit = null;
            this.gradunit = null;
            this.gradunit_eng = null;
            this.getProdudtGrade(this.productid);
            this.isaddgrade = true;
          })
          .catch((error) => {
            console.log(error);
            if (error == "Error: Request failed with status code 400") {
              this.$swal("Check Input Data", "", "error");
            } else {
              this.$swal("ມີຂໍ້ຜິດພາດ: " + error, "-", "error");
            }
          });
      }
    },
    
    addProductGrade() {
      if ( this.productgrade === null || this.productgrade === "" || 
         this.productgrade_eng === null || this.productgrade_eng === "" || 
         this.subunit === null || this.subunit === "" ||
         this.gradunit === null || this.gradunit === "" || 
         this.gradunit_eng === null || this.gradunit_eng === "" || 
         this.price === null || this.price === "" ||  this.price == 0 || 
         this.selectedB2BType === null || this.selectedB2BType.length === 0) 
      {
         this.$swal("ກະລຸນາປ້ອນຂໍ້ມູນໃຫ້ຄົບຖ້ວນ", "", "error");
      } else {
        var params = {
          productid: this.productid,
          productgrade: this.productgrade,
          productgrade_eng: this.productgrade_eng,
          subunit: this.subunit,
          gradunit: this.gradunit,
          gradunit_eng: this.gradunit_eng,
          price: this.price,
          photoname: this.productphotoname,
          b2bpackingtype: this.selectedB2BType.ID,
          username: this.username,
        };
        // console.log("params: " + JSON.stringify(params));
        RestAPI.addProductGrade(params)
          .then(res => {
            if(res.data === "morethan1"){
              this.$swal("ມີອັດຕາສ່ວນເທົ່າ 1 ແລ້ວ", "", "error");
              return false;
            }

            this.photopreview = null;
            this.$swal("ເພີ່ມເກຼດສິນນຄ້າ ສຳເລັດ!", "", "success");
            this.productgrade = null;
            this.productgrade_eng = null;
            this.subunit = null;
            this.gradunit = null;
            this.gradunit_eng = null;
            this.price = null;
            this.getProdudtGrade(this.productid);
          })
          .catch((error) => {
            console.log(error);
            if (error == "Error: Request failed with status code 400") {
              this.$swal("Check Input Data", "", "error");
            } else {
              this.$swal("ມີຂໍ້ຜິດພາດ: " + error, "-", "error");
            }
          });
      }
    },

    updateProductForm(data) {
      console.log(data);
      this.activeTab = 0;
      this.saveAction = false;
      this.updateAction = true;
      this.oldproductname = data.PRODUCTNAME;
      this.productname = data.PRODUCTNAME;
      this.oldproductnameen = data.PRODUCTNAMEEN;
      this.productnameen = data.PRODUCTNAMEEN;
      this.specialname = data.SPECIALNAME;
      // this.selectedHarvesttype = data.PRODUCTTYPEID;
      this.selectedHarvesttype = {
        ID: data.HARVESTONE,
        NAME: data.HARVESTONENAME,
      };
      this.productid = data.PRODUCTID;
      this.unit = data.UNIT;
      this.photoname = data.PHOTONAME;
      this.typeid = data.PRODUCTTYPEID;
      this.selectedType = {
        ID: data.PRODUCTTYPEID,
        NAME: data.PRODUCTTYPENAME,
      };
      this.photopreview = this.photopath + data.PHOTONAME;
    },
    openSaveBranchForm() {
      this.activeTab = 0;
      this.saveAction = true;
      this.updateAction = false;
      this.productname = null;
      this.productnameen = null;
      this.unit = null;
      this.photoname = null;
      this.specialname = null;
    },
    updateProduct() {
      // console.log("selectedHarvesttype:" + JSON.stringify(this.selectedHarvesttype))
      if(!this.disabledstate){ // no harvest
        if (
          this.productname === null ||
          this.productnameen === null ||
          this.unit === null ||
          this.selectedType === null
        ) {
          this.$swal("ກະລຸນາປ້ອນຂໍ້ມູນໃຫ້ຄົບຖ້ວນ", "", "error");
          return false;
        }
      }else{ // harvest
        if ( 
          this.productname === null ||
          this.productnameen === null ||
          this.unit === null ||
          this.selectedType === null ||
          this.selectedHarvesttype.ID === null
        ) {
          this.$swal("ກະລຸນາປ້ອນຂໍ້ມູນໃຫ້ຄົບຖ້ວນ", "", "error");
          return false;
        }

      }
      

      var params = {
        productid: this.productid,
        productname: this.productname,
        specialname: this.specialname,
        oldproductname: this.oldproductname,
        productnameen: this.productnameen,
        oldproductnameen: this.oldproductnameen,
        typeid: this.selectedType.ID,
        unit: this.unit,
        harvesttype: this.disabledstate ? this.selectedHarvesttype.ID : 2,
        photoname: this.photoname,
        username: this.username,
      };

      console.log("pa: " + JSON.stringify(params));

      RestAPI.updateProduct(params)
        .then((res) => {
          // console.log("data: "+ JSON.stringify(res.data))
          if (res.data == "duplicate productname") {
            this.$swal("ຊື່ສິນຄ້າຊ້ຳ", "-", "error");
            return false;
          }

          this.photopreview = null;
          this.activeTab = 1;
          this.saveAction = true;
          this.updateAction = false;
          this.branchname = null;
          this.countryid = null;
          this.provinceid = null;
          this.getProducts();
        })
        .catch((error) => {
          console.log(error);
          if (error == "Error: Request failed with status code 400") {
            this.$swal("Check Input Data", "", "error");
          } else {
            this.$swal("ມີຂໍ້ຜິດພາດ: " + error, "-", "error");
          }
        });
      
    },
    changeProductStatus(productid, status) {
      this.$swal({
        title: "ຕ້ອງານດຳເນີນການແທ້ບໍ່?",
        showCancelButton: true,
        showCloseButton: true,
        confirmButtonText: "ຕ້ອງການ",
        cancelButtonText: "ບໍ່ຕ້ອງການ",
        confirmButtonColor: "#d33",
        cancelButtonColor: "#3085d6",
      }).then((result) => {
        if (result.value) {
          var params = {
            productid: productid,
            status: status,
            username: this.username,
          };
          console.log("pararm: " + JSON.stringify(params));
          RestAPI.changeProductStatus(params)
            .then(() => {
              this.$swal("ດຳເນີນການສຳເລັດ!", "", "success");
              this.getProducts();
            })
            .catch((error) => {
              this.$swal("ມີຂໍ້ຜິດພາດ: " + error, "-", "error");
            });
        }
      });
    },

    changeProductGrade(data) {
      this.$swal({
        title: "ຕ້ອງານດຳເນີນການແທ້ບໍ່?",
        showCancelButton: true,
        showCloseButton: true,
        confirmButtonText: "ຕ້ອງການ",
        cancelButtonText: "ບໍ່ຕ້ອງການ",
        confirmButtonColor: "#d33",
        cancelButtonColor: "#3085d6",
      }).then((result) => {
        if (result.value) {
          var params = {
            id: data.ID,
            status: data.STATUS ==1 ? 0 : 1,
            username: this.username,
          };
          // console.log("pararm: " + JSON.stringify(params));
          RestAPI.changeProductGrade(params)
            .then(() => {
              this.$swal("ດຳເນີນການສຳເລັດ!", "", "success");
              this.getProdudtGrade(data.PRODUCTID);
            })
            .catch((error) => {
              this.$swal("ມີຂໍ້ຜິດພາດ: " + error, "-", "error");
            });
        }
      });
    },

    onFileSelected(event) {
      this.isSelectPhoto = true;
      // console.log("url: "+ this.url)
      // console.log("photopath: " + this.photopath)
      this.selectedFile = event.target.files[0];
      const fd = new FormData();
      fd.append("image", this.selectedFile);
      axios.post(this.url, fd).then((res) => {
        this.photoname = res.data;
        this.photopreview = this.photopath + res.data;
      });
    },
    getImgUrl(photoname) {
      var photopreview = photoname
        ? this.photopath + photoname
        : this.photopath + "unknown.png";
      // console.log("photoname: " + photoname)
      // console.log("photopreview: " + photopreview)
      return photopreview;
    },
    productSearch() {
      this.selectedTypeSearch = null;
      // this.search = null;
      this.selectedHarvestSearch = null;

      if (this.search) {
        var params = {
          search: this.search,
        };
        RestAPI.searchClinicProducts(params)
          .then((res) => {
            this.activeproducts = res.data.activeproducts;
            this.inactiveproducts = res.data.inactiveproducts;
            // console.log("products: " + JSON.stringify(this.products));
          })
          .catch((error) => {
            console.log(error);
            this.$swal("ມີຂໍ້ຜິດພາດ", "-", "error");
          });
      } else {
        this.getProducts();
      }
    },
    productTypeSelectedSearch() {
      // console.log("productTypeSelectedSearch");
      // console.log("this.selectedTypeSearch.ID: " + this.selectedTypeSearch.ID);
      // this.selectedTypeSearch = null;
      this.search = null;
      this.selectedHarvestSearch = null;
      if (this.selectedTypeSearch) {
        var params = {
          typeid: this.selectedTypeSearch.ID,
        };
        RestAPI.clinicProductTypeSelectedSearch(params)
          .then((res) => {
            this.activeproducts = res.data;
            console.log("res: " + JSON.stringify(res.data));
          })
          .catch((error) => {
            console.log(error);
            this.$swal("ມີຂໍ້ຜິດພາດ", "-", "error");
          });
      } else {
        this.getProducts();
      }
    },
    onHarvestSearch() {
      this.selectedTypeSearch = null;
      this.search = null;
      // this.selectedHarvestSearch = null;

      // console.log("this.selectedHarvestSearch.ID: " + this.selectedHarvestSearch.ID);

      if (this.selectedHarvestSearch) {
        var params = {
          typeid: this.selectedHarvestSearch.ID,
        };
        RestAPI.clinicProductHarvestSelectedSearch(params)
          .then((res) => {
            this.activeproducts = res.data;
            console.log("res: " + JSON.stringify(res.data));
          })
          .catch((error) => {
            console.log(error);
            this.$swal("ມີຂໍ້ຜິດພາດ", "-", "error");
          });
      } else {
        this.getProducts();
      }
    },
    print() {
      window.print();
    },
  },
  mounted() {
    this.roleid = this.user.ROLEID;
    this.username = this.user.USERNAME;
    
    this.getProducts();
    this.getProductTypes();
    this.getResponseUser();
    // this.getAllProvince();

  },
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
